import mutations from './mutations';
import getters from './getters';
import actions from './actions';
import initialState from './initialState';

export default {
  namespaced: true,
  mutations,
  getters,
  actions,
  state: {
    ...initialState,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/companies/index.js